/**
 * Plain-DOM equivalents of the jQuery helpers used by the legacy Jacada/Uniphore
 * bundle (`lib.getDomElementFromSelector`, `.is(':visible')`, `.val() || .text()`).
 * No jQuery dependency, matching this repo's stack.
 */

export const isElementVisible = (el: Element | null): boolean => {
  if (!el) return false;
  const style = window.getComputedStyle(el);
  return style.display !== "none" && style.visibility !== "hidden";
};

export const queryVisibleElement = (selector: string): Element | null => {
  if (!selector) return null;
  const el = document.querySelector(selector);
  return isElementVisible(el) ? el : null;
};

/**
 * Mirrors `el.val() || el.text()`: prefers a form value, falls back to text content.
 */
export const getElementValue = (el: Element | null): string => {
  if (!el) return "";
  if (
    el instanceof HTMLInputElement ||
    el instanceof HTMLTextAreaElement ||
    el instanceof HTMLSelectElement
  ) {
    return el.value || el.textContent || "";
  }
  return el.textContent || "";
};

/**
 * Mirrors `lib.isNullSelector`: "clear to fire" only if none of the given
 * selectors currently resolve to a visible element.
 */
export const isNullSelector = (selectors?: string[]): boolean => {
  if (!selectors || !selectors.length) return true;
  return !selectors.some((selector) => !!queryVisibleElement(selector));
};
